import { Slice } from '~common/store';
import Reservation from '~kint/models/Reservation.ts';
import callReservation from '~kint/controllers/callReservation.ts';
import { Team } from '~kint/models/Team.ts';
import callTeam from '~kint/controllers/callTeam.ts';

export interface ReservationSlice {
  tourId: string | null;
  reservationOn: boolean;
  team: Team | null;
  reservationKey: string | null;
  reservation: Reservation | null;
  setReservation: (reservation: Reservation | null) => void;
  setReservationKey: (reservationKey: string) => void;
  name: string | null;
  setName: (name: string | null) => void;
  syncReservation: () => Promise<void>;
}

export interface PersistedReservationSlice {
  tourId: string | null;
  team: Team | null;
  reservationKey: string | null;
  reservation: Reservation | null;
  name: string | null;
}

export const persistReservationSlice: (state: ReservationSlice) => PersistedReservationSlice = (
  state
) => ({
  tourId: state.tourId,
  team: state.team,
  reservationKey: state.reservationKey,
  reservation: state.reservation,
  name: state.name,
});

export const createReservationSlice: Slice<ReservationSlice> = (set, get, store) => ({
  tourId: null,
  team: null,
  reservationOn: !!get()?.reservation,
  reservationKey: null,
  reservation: null,
  setReservationKey: (reservationKey: string) => set(() => ({ reservationKey })),
  setReservation: async (reservation: Reservation | null) => {
    const team = reservation?.id ? await callTeam(reservation?.id) : null;
    set(() => ({ reservation, team }));
  },
  name: null,
  setName: (name: string | null) => set(() => ({ name })),
  syncReservation: async () => {
    const existReservation = get().reservation;
    const existKey = get().reservationKey;
    const mismatched =
      !existReservation ||
      (existReservation.id !== existKey && existReservation.agencyCode !== existKey);
    if (mismatched) {
      return;
    }
    try {
      const syncedReservation = await callReservation(existKey);
      if (JSON.stringify(store.getState().reservation) !== JSON.stringify(syncedReservation))
        if (syncedReservation) set(() => ({ reservation: syncedReservation }));
    } catch (e) {
      console.error(e);
    }
  },
});

export const mergeReservationPersistedSlice = (
  persistedState: unknown,
  currentState: ReservationSlice
): ReservationSlice => {
  const syncState = { ...currentState, ...(persistedState ?? {}) };
  return {
    ...syncState,
    reservation: syncState.reservation ? new Reservation(syncState.reservation) : null,
  };
};
